import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import TeamSection from '../components/TeamSection';
import {
  labMembers,
  undergraduateResearchers,
  alumni,
} from '../data/teamData';

const Team: React.FC = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <div className="pt-20 md:pt-24">
      <section
        ref={ref}
        className="py-20 md:py-28 bg-white min-h-screen"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-penn-blue mb-6">
              Our Team
            </h1>
            <div className="w-24 h-1 bg-penn-red mx-auto mb-8"></div>
            <p className="text-lg md:text-xl text-neutral-dark max-w-3xl mx-auto leading-relaxed">
              Our diverse team brings together expertise in neuroscience, medicine, and behavioral science to tackle fundamental questions
              about brain function.
            </p>
          </motion.div>

          {/* Cichon Lab Members */}
          <TeamSection
            title="Cichon Lab Members"
            members={labMembers}
          />

          {/* Undergraduate Researchers */}
          <TeamSection
            title="Undergraduate Researchers"
            members={undergraduateResearchers}
          />

          {/* Alumni */}
          <TeamSection title="Alumni" members={alumni} />
        </div>
      </section>
    </div>
  );
};

export default Team;


